import axios from 'axios';

import { getUrls } from './url';
import { CLASS_INFO } from '../config/apiPaths';

export const getClassMeeting = async (classUuid: string) => {
    const { api } = getUrls();
    const response = await axios.get<ClassResponse>(api + CLASS_INFO, { params: { class_id: classUuid } });

    return response.data;
};

export type ClassResponse = {
    sid: number;
    school_name: string;
    class_name: string;
    class_code: string;
    courseid: string;
    data: Data;
    random_value: number;
    meeting_id: string;
    class_uuid: string;
    class_number: string;
    settings_data: SettingsData;
    date_created: Date;
    class_description: string;
    type: string;
    status: string;
    lti_state: null;
    content_type: string;
};

export type Data = {
    timezone: string;
    class_code: string;
    class_name: string;
    class_times: string;
    content_type: string;
    class_description: string;
};

export type SettingsData = {
    has_files: boolean;
    auto_verify: boolean;
    content_counts: any[];
    share_setting_type: number;
    syllabus_content_id: number;
    selected_chat_option: string;
};
